import $fn from "@/utils/fn";
export const columns = [
  {
    title: "ID",
    key: "id",
    align: "center",
  },
  {
    title: "提现时间",
    key: "apply_time",
    render: (h, params) => {
      return h("span", $fn.toDateSymbol(params.row.apply_time));
    },
    align: "center",
  },
  {
    title: "提现盒子号",
    key: "account",
    render: (h, params) => {
      const str = `${params.row.account}（${params.row.uid}）`;
      return h("span", str);
    },
    align: "center",
  },
  {
    title: "提现类型",
    key: "extract_type",
    render: (h, params) => {
      return h("span", params.row.extract_type == 1 ? "支付宝" : "盒币");
    },
    align: "center",
  },
  {
    title: "提现金额",
    key: "total_extract_money",
    align: "center",
  },
  {
    title: "手续费",
    key: "extarct_charge_money",
    align: "center",
  },
  {
    title: "使用抵扣券",
    key: "use_coupon_money",
    align: "center",
  },
  {
    title: "提现支付宝账号",
    key: "alipay_account",
    align: "center",
  },
  {
    title: "提现ip",
    key: "ip",
    align: "center",
  },
  {
    title: "提现设备",
    key: "device",
    align: "center",
  },
  {
    title: "绑定手机号",
    key: "phone",
    align: "center",
  },
  {
    title: "异常原因",
    key: "speed_up_state_txt",
    align: "center",
  },
  {
    title: "操作",
    slot: "status",
    align: "center",
    width: 300,
  },
];

export const remitList = [
  // { id: 0, name: "未打款" },
  { id: 1, name: "已打款" },
  // { id: 2, name: "打款失败" },
  // { id: 3, name: "待放款" },
  { id: 5, name: "撤销提现" },
  { id: 4, name: "已经退回" },
];
